import React, { useState, useEffect, useContext } from "react";
import creditcard from "../assets/images/Overview/credit-card.svg";
import Bank from "../assets/images/Overview/Bank_Account.svg";
import { Modal, Spinner } from "react-bootstrap";
import trash from "../assets/images/Overview/trash.svg";
import RemoveAccountModal from "../components/removeAccountModal";
import { toast } from 'react-toastify';
import { getApiService } from "../services/ApiService";
import { GetPayLoad } from "../services/PayLoadStorage";
import { LanguageContext } from "../contexts/LanguageContext";
import Cookies from "js-cookie";

const RemoveAccounts = ({ activeModal }) => {

    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    const Payload = GetPayLoad('PayLoad');
    const headers = {
        "X-Hps-Client-Id": process.env.REACT_APP_API_CLIENT_ID,
        "X-Hps-Secret-Id": process.env.REACT_APP_API_SECRET_ID,
        "X-Hps-Region": Payload?.region
    };

    const [isLoading, setLoading] = useState(true);
    const [activeAccounts, setActiveAccounts] = useState([]);
    const [removeModal, setRemoveModal] = useState(false);
    const [accountName, setAccountName] = useState();
    const [vaultId, setVaultId] = useState();
    const [accountType, setAccountType] = useState();
    const [apiCall, setApiCall] = useState(true);
    const [primaryAccount, setPrimaryAccount] = useState([]);
    const [errorFlag, setErrorFlag] = useState(false);

    const { pageContent } = useContext(LanguageContext);
    const [overViewContent, setOverViewContent] = useState([]);
    const [genericContent, setGenericContent] = useState([]);

    useEffect(() => {
        if (pageContent?.overview) {
            setOverViewContent(pageContent.overview);
        }

        if (pageContent?.generic) {
            setGenericContent(pageContent.generic);
        }
        
        if (activeModal && apiCall) {
            fetchAPI();
        }
    
    }, [pageContent]);

    const handleRemoveModal = (accName, vaultId, accountType) => {
        setRemoveModal(true);
        setAccountName(accName);
        setVaultId(vaultId);
        setAccountType(accountType);
    }

    function handleDataFromModal(message, response) {
        if (message !== '') {
            if(response === 'success'){
                toast.success(message);
            }else{
                toast.error(message);
            }
            fetchAPI();
        }
    }
    
    function fetchAPI() {
        const targetGetActiveAccountsUrl = process.env.REACT_APP_API_GET_ACTIVE_ACCOUNTS_ENDPOINT;
        getApiService(baseUrl, targetGetActiveAccountsUrl, { cim: Payload?.cim }, headers)
            .then((response) => {
                setLoading(false);
                if (response?.data?.statusCode !== 200) {
                    setErrorFlag(true);
                }else{
                    const result = response.data.data;
                    setActiveAccounts(result);
                    setErrorFlag(false);
                    setApiCall(false);

                    if(result.length > 0){
                        const targetGetPrimaryAccountUrl = process.env.REACT_APP_API_GET_PRIMARY_ACCOUNT_ENDPOINT;
                        getApiService(baseUrl, targetGetPrimaryAccountUrl, { cim: Payload?.cim }, headers)
                        .then((response) => {
                            if (response?.data && response?.data?.status === 'SUCCESS') {
                                const result = response.data.data;
                                setPrimaryAccount(result);
                                setLoading(false);
                                setApiCall(false);
                            }
                        })
                        .catch(error => {
                            console.error('Error fetching primary account data:', error);
                        });
                    }
                }
            })
            .catch(error => {
                setLoading(false);
                setErrorFlag(true);
            });
    }

    return (
        <>
            <Modal size="x1" show={removeModal} onHide={() => { setRemoveModal() }}>

                <RemoveAccountModal accountName={accountName} vaultId={vaultId} accountType={accountType} setRemoveModal={setRemoveModal} sendDataToParent={handleDataFromModal} />
            </Modal>
            <Modal.Header className={`modal-header pb-4 removeaccounts ${Payload?.owning_carrier === 'Q5' ? 'mobile-close-btn' : ''}`} closeButton>
                <Modal.Title tabIndex={0}>{overViewContent?.overview_remove_accounts_title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div tabIndex={0} className="grey-bg rounded px-4 py-4 mb-4 custom-rounded">
                    <p>
                        <b>{overViewContent?.overview_multiple_accounts_note}</b>
                        {overViewContent?.overview_remove_accounts_note_content}
                    </p>
                </div>
                {errorFlag && (
                    <div tabIndex={0} className="api-error-msg">
                        {genericContent?.accounts_info_service_error}
                    </div>
                )}
                {isLoading && (
                    <div tabIndex={0} style={{ display: 'flex', alignItems: 'center', gap: '15px', margin: 'inherit' }}>
                        <Spinner animation="border" role="status" ></Spinner>
                        <div style={{ fontSize: "12px" }}>{genericContent?.loading_message}</div>
                    </div>
                )}
                {!isLoading && activeAccounts.length > 0 ? (
                    <div className="accounts" style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                        {
                            activeAccounts && activeAccounts?.map((item, index) => 
                            {
                                let hideCreditCard = Cookies.get("owningCarrier") === "Q5" &&
                                                        item?.cardType === "CCD" &&
                                                        Cookies.get("binder_payment_flag") === "false"
                                                            ? true
                                                            : false;
                                return (
                                    !hideCreditCard && (
                                    <div className={(primaryAccount?.MainAccountType === item?.mainAccountType && primaryAccount?.vault_id === item?.vaultId && primaryAccount?.primaryActive === 'Y') ? 'primaryActive' : 'primaryDefault'} key={index} style={{ padding: '15px', display: 'flex', justifyContent: 'space-between', borderRadius: '15px' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                                            <div tabIndex={0} className="paymode-bg rounded-circle text-center">
                                                <img width={item?.mainAccountType !== 'EFT' ? '24px' : '27px'} height={item?.mainAccountType !== 'EFT' ? '24px' : '27px'} src={item?.mainAccountType === 'EFT' ? Bank : creditcard} alt="creditcard" />
                                            </div>
                                            <div className="accounts" style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '15px' }}>
                                                <div tabIndex={0}>
                                                    <h4 className="more-h4" >{item?.mainAccountType === 'EFT' ? overViewContent?.overview_remove_accounts_eft_account : overViewContent?.overview_remove_accounts_card_number }</h4>
                                                    <label className="more-label">{item?.mainAccountType === 'EFT' ? overViewContent?.overview_remove_accounts_eft_account_number : overViewContent?.overview_remove_accounts_card_number_star } {item?.accountNumLastFour}</label>
                                                </div>
                                                <div tabIndex={0}>
                                                    <h4 className="more-h4">{item?.mainAccountType === 'EFT' ? overViewContent?.overview_multiple_accounts_account_type : overViewContent?.overview_multiple_accounts_card_exp_date }</h4>
                                                    <label className="more-label">{item?.mainAccountType === 'EFT' ? (genericContent?.[
                                                        "account_type_" +
                                                        item?.detailedAccountType.toLowerCase()
                                                    ] || item?.detailedAccountType) : item?.ExpiryDate}</label>
                                                </div>
                                            </div>
                                        </div> 

                                        <div className="accounts" style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '15px' }}>
                                            {(primaryAccount?.MainAccountType === item?.mainAccountType && primaryAccount?.vault_id === item?.vaultId && primaryAccount?.primaryActive === 'Y') ?
                                            (<button className={Payload?.owning_carrier === 'Q5' ? 'btn btn-outline-secondary btn-md rounded' : 'btn btn-warning btn-sm rounded'}>{overViewContent?.overview_multiple_accounts_primary_account}</button>)
                                                :(
                                                <div tabIndex={0} style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '5px', cursor: 'pointer' }} onClick={(e) => handleRemoveModal(item?.accountName, item?.vaultId, item?.accountType, e)}>
                                                    <img src={trash} alt="delete account" />
                                                    <label className="more-label" style={{ paddingTop: '5px' }}>{overViewContent?.overview_remove_accounts_remove_label}</label>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    )
                                )
                            })
                        }
                    </div>
                )
                :
                (
                    (!isLoading && !errorFlag) && (
                        <div className='labels'><label className='label-heading'>{overViewContent?.overview_multiple_accounts_no_data_text}</label></div>
                    )
                )
                }
            </Modal.Body>

        </>
    )
}

export default RemoveAccounts;